import {
  HIDE_ERROR,
  SET_ERROR_MSG,
  SET_ERROR_MSG_IN_MODAL,
  SHOW_ERROR,
  SHOW_ERROR_IN_MODAL,
} from './GlobalErrorComponent.constant';

export const showError = () => ({
  type: SHOW_ERROR,
});

export const showErrorInModal = () => ({
  type: SHOW_ERROR_IN_MODAL,
});

export const hideError = () => ({
  type: HIDE_ERROR,
});

export const setGlobalError = (payload) => ({
  type: SET_ERROR_MSG,
  payload,
});

export const setModalError = (payload) => ({
  type: SET_ERROR_MSG_IN_MODAL,
  payload,
});
